import React from 'react';
import DocumentSVG from '../assets/Document.jsx'
import { Link } from 'react-router-dom'; 
import AddSVG from '../assets/Add.jsx';
import { useMediaQuery } from 'react-responsive';

const NewContractButton = ({ width, height, textSize, iconWidth, iconHeight, email, onClick}) => {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  const handleClick = (e) => {
    e.stopPropagation();
    console.log('About to record custom event');
    newrelic.recordCustomEvent('AnalyticEvent', { 
      element: 'NewContractButton', 
      action: 'click', 
      email 
    });
    if (onClick) onClick(e);
  };

  return (
    // <div className='flex justify-center items-center z-10'>
    <Link to="/newcontractform" 
          className={`w-[${width}px] h-[${height}px]} justify-center items-center md:px-2 md:py-1 p-[2px] bg-shi-green rounded-lg hover:bg-slate-500 inline-flex`}  
          onClick={handleClick}
    >
      {isMobile ? 
      <div className='w-8 flex justify-center'>
        <AddSVG width={20} height={20} fill='#FFFFFF'/>
      </div>
        : 
        <span className={`text-center items-center justify-center text-white text-[${textSize}px]`}>
          NEW CONTRACT
        </span>
      }
    </Link>
    // </div>
  );
};

export default NewContractButton;